import { Preferences } from '@capacitor/preferences'

export function useSubdomainCookie() {
  const url = useRequestURL()
  const hostname = url.hostname
  const isNative = useIsNative()

  function getDomain() {
    let domain = '.casewiseapp.com'

    if (hostname.includes('vercel.app')) {
      domain = `${window?.location?.hostname?.split('.')?.[0] ?? ''}.vercel.app`
    }

    if (hostname.includes('localhost')) {
      domain = 'localhost'
    }

    return domain
  }

  async function setSubdomainCookie(subdomain: string) {
    if (!subdomain) return

    const domain = getDomain()

    const cookieSubdomain = useCookie('subdomain', {
      domain,
      sameSite: 'lax',
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year
    })

    cookieSubdomain.value = subdomain

    if (isNative) {
      await Preferences.set({
        key: 'subdomain',
        value: subdomain,
      })
    }
  }

  return {
    setSubdomainCookie,
  }
}
